import { TimeOfDay } from '@dreryk/egabinet-waitlist-frontend-api';

import { TranslateFunction } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

const TIMES_OF_DAY_MAX_COUNT = 3;

export const formatTimesOfDay = (timesOfDay: TimeOfDay[], translate: TranslateFunction): string => {
   if (timesOfDay.length === TIMES_OF_DAY_MAX_COUNT) {
      return translate(translationKeys.withoutRestrictions);
   }
   return timesOfDay.map((timeOfDay) => translate(translationKeys.timeOfDayMap[timeOfDay])).join(', ');
};
